/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Checkout/PayPal',[
    'jquery',
    'global/all'
], function($, Roc) {
    'use strict';

    var viewModel = {};
    var addressType = 'pp-billing';
    var wrapperSelector;
    var payPalPayerIdCookieKey = "PayPalPayerId";
    var payPalTokenCookieKey = "PayPalToken";

    // TODO: replace this with mapping to PayPal.Forms.js
    var forms = {
        payPal: {
            Fields: [
                {
                    "Name": 'Paypal token',
                    "Field": '#pp-token',
                    "Param": 'payPaltoken',
                    "Type": 'Hidden'
                },
                {
                    "Name": 'Paypal payer id',
                    "Field": '#pp-payer-id',
                    "Param": 'payPalPayerId',
                    "Type": 'Hidden'
                }
            ],
            Validate: true,
            RequestParam: 'payPal',
            ErrorMsg: 'Invalid PayPal configuration'
        },
        billingAddress: {
            Fields: [
                {
                    "Name": 'First Name',
                    "Field": '#pp-billing-first-name',
                    "Param": 'firstName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Last Name',
                    "Field": '#pp-billing-last-name',
                    "Param": 'lastName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Company',
                    "Field": '#pp-billing-company',
                    "Param": 'company',
                    "Type": 'Text',
                    "Optional": true
                },
                {
                    "Name": 'Address 1',
                    "Field": '#pp-billing-address1',
                    "Param": 'address1',
                    "Type": 'Text'
                },
                {
                    "Name": 'Address 2',
                    "Field": '#pp-billing-address2',
                    "Param": 'address2',
                    "Type": 'Text',
                    "Optional": true
                },
                {
                    "Name": 'City',
                    "Field": '#pp-billing-city',
                    "Param": 'city',
                    "Type": 'Text'
                },
                {
                    "Name": 'State',
                    "Field": '#pp-billing-state',
                    "Param": 'state',
                    "Type": 'Select'
                },
                {
                    "Name": 'Region',
                    "Field": '#pp-billing-region',
                    "Param": 'region',
                    "Type": 'Text',
                    "Optional": true
                },
                {
                    "Name": 'Country',
                    "Field": '#pp-billing-country',
                    "Param": 'country',
                    "Type": 'Select'
                },
                {
                    "Name": 'Zip/Postal Code',
                    "Field": '#pp-billing-zip',
                    "Param": 'zip',
                    "Type": 'Text',
                    'Optional': true,
                    "Validators": [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '#pp-billing-country',
                                'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                                'ConditionalValue': 'true',
                                'ConditionalFieldType': 'Select'
                            },
                            {
                                "Type": 'Zip',
                                "ReferencedField": '#pp-billing-country',
                                'ReferencedFieldAttr': 'data-isPostalCodeRequired',
                                'ReferencedValue': 'true',
                                'ReferencedFieldType': 'Select'
                            }
                    ]
                },
                {
                    "Name": 'Phone',
                    "Field": '#pp-billing-phone',
                    "Param": 'phone',
                    "Type": 'Text'
                },
                {
                    "Name": 'Is Default',
                    "Field": '#pp-billing-hdAddressIsDefault',
                    "Param": 'isDefault',
                    "Type": 'Hidden',
                    "DefaultValue": 'false'
                }
            ],
            Validate: true
        },
        selectedBillingAddress: {
            Fields: [
                {
                    "Name": 'Billing address Id',
                    "Field": '#pp-billing-hdAddressId',
                    "Param": 'creditCardData.addressId',
                    "Type": 'Hidden',
                    "GetValueMethod": { fn: getSelectedBillingAddressId }
                }
            ],
            Validate: true,
            RequestParam: 'billingAddressId',
            RequestParamType: 'SingleValue',
            ErrorMsg: 'Please select billing address or create a new one.'
        }
    };

    function getSelectedBillingAddressId() {
        return Roc.UI.getItemId('.' + viewModel.address.btns.btnSelected.cssClass);
    };

    /**
     * Determines whether PayPal payment has been accepted
     * @returns {} 
     */
    function isPaymentAccepted() {
        return viewModel.token !== undefined && viewModel.token !== null && viewModel.payerId !== undefined && viewModel.payerId !== null;
    }
    
    /**
     * Populates view model data from given model object
     * @param {Object} model 
     * @returns {} 
     */
    function initWithData(model) {
        if (model && model.payPalPaymentInfo) {
            viewModel.token = model.payPalPaymentInfo.token;
            viewModel.payerId = model.payPalPaymentInfo.payerId;
        }
        viewModel.isAccepted = isPaymentAccepted();
    }

    /**
     * Populates view model data from cookies
     * @returns {} 
     */
    function initFromCookies() {
        viewModel.token = Roc.Core.getCookie(payPalTokenCookieKey);
        viewModel.payerId = Roc.Core.getCookie(payPalPayerIdCookieKey);
        viewModel.isAccepted = isPaymentAccepted();
    }

    function initializeExternalCheckout() {
        $.ajax({
            type: 'GET',
            url: '/ajax/InitializePayPalExpressCheckout',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            complete: function (xhr) {
                var response = xhr.responseJSON || {};
                if (response.success && response.redirectUrl) {
                    window.location.replace(response.redirectUrl);
                } else if (response.errorMessage) {
                    Roc.UI.displayErrorPopup(response.errorMessage);
                }
            }
        });
    }

    function checkoutPaymentTypeChangedEvt(paymentType) {
        if (paymentType.name === 'PayPal' && !viewModel.isAccepted) {
            initializeExternalCheckout();
        }
    }

    function expressCheckoutButtonVisibilityEvt() {
        Roc.EventManager.bind(Roc.Events.cart.GET_SUMMARY, function(xhr) {
            var summary = xhr.responseJSON || {};
            if (summary.hasOwnProperty('items') && parseInt(summary.items) <= 0) {
                $(wrapperSelector).hide();
            } else {
                $(wrapperSelector).show();
            }
        });
    }

    function selectedBillingAddress(addressId) {
        $('#pp-billing-hdAddressId').val(addressId);
    }

    function unSelectBillingAddress() {
        Roc.UI.swapButtons(viewModel.address.btns, null);
        selectedBillingAddress(null);
    }

    function addNewAddressEvt() {
        Roc.UI.siteBody
            .off('click', '#pp-billing-addNewAddress')
            .on('click', '#pp-billing-addNewAddress', function () {
                unSelectBillingAddress();
                $('#pp-new-address-form-wrapper').show();
                $('#pp-select-address-wrapper').hide();
            });
    }

    function expressCheckoutButtonEvt() {
        Roc.UI.siteBody
            .off('click', 'a#paypalExpressCheckoutBtn')
            .on('click', 'a#paypalExpressCheckoutBtn', function(e) {
                e.preventDefault();
                initializeExternalCheckout();
            });
    }

    function cancelAddNewAddressEvt() {
        Roc.UI.siteBody
            .off('click', '#pp-cancelAddNewAddress')
            .on('click', '#pp-cancelAddNewAddress', function() {
                $('#pp-select-address-wrapper').show();
                $('#pp-new-address-form-wrapper').hide();
            });
    }

    function useAddressEvt() {
        Roc.UI.btnUseThisClickEvt(viewModel.address.btns, function(addressId) {
            selectedBillingAddress(addressId);
        });
    }

    function openBillingForm() {
        unSelectBillingAddress();
        $('#pp-new-address-form-wrapper').show();
        $('#pp-select-address-wrapper').hide();
    }

    function populateBillingAddress() {
        Roc.Forms.populateData(viewModel.billingAddress, forms.billingAddress);
    }

    function loadBillingData() {
        if (viewModel.expandBillingForm) {
            populateBillingAddress();
            openBillingForm();
        }
    }

    function getAddressViewModel(addr) {
        addr.btnUseThis = viewModel.address.btns.btnUseThis;
        addr.btnSelected = viewModel.address.btns.btnSelected;
        return addr;
    };

    function loadViewModelDetails() {
        $.each(viewModel.addressList, function (i, addr) {
            getAddressViewModel(addr);
        });
    }

    function newAddressFormActive() {
        return $('#pp-new-address-form-wrapper').is(':visible');
    };

    function bindCheckoutEvents() {
        addNewAddressEvt();
        useAddressEvt();
        cancelAddNewAddressEvt();
        expressCheckoutButtonEvt();
        Roc.UI.bindAddressFormEvents(addressType);
        loadBillingData();
        Roc.EventManager.bind(Roc.Events.checkout.PAYMENT_TYPE_CHANGED, checkoutPaymentTypeChangedEvt);
    }

    function bindEvents() {
        expressCheckoutButtonEvt();
        expressCheckoutButtonVisibilityEvt();
    }

    function init(contentSelector) {
        initFromCookies();
        wrapperSelector = contentSelector;
        Roc.UI.renderFormTemplate('paypalExpressCheckout-Tmp', viewModel, $(wrapperSelector))
            .then(function () {
                bindEvents();
            });

        return viewModel;
    }

    function initCheckout(model) {
        viewModel = {
            addressType: addressType,
            countries: model.countries || {},
            states: model.states || {},
            addressList: model.addresses || {},
            address: {
                btns: {
                    btnUseThis: { cssClass: 'pp-useThisBillingAddress', text: 'Use this address' },
                    btnSelected: { cssClass: 'pp-selected', text: 'Selected address' }
                }
            },
            billingAddress: model.order.billingAddress,
            prefix: 'pp-',
            expandBillingForm: model.expandBillingForm,
            displayAddressBookEntries: (model.addresses && model.addresses.length > 0)
        };
        viewModel.billingAddress.isDefault = false;
        initWithData(model);
        loadViewModelDetails();
        viewModel.forms = forms;

        if (viewModel.isAccepted) {
            Roc.UI.info('Payment will be submitted through PayPal.');
        }

        return viewModel;
    }

    var PayPal = {
        initCheckout: initCheckout,
        init: init,
        bindCheckoutEvents: bindCheckoutEvents,
        newAddressFormActive: newAddressFormActive,
        loadBillingData: loadBillingData
    };

    Roc.Logger.debug('PayPal.js Loaded:', PayPal);

    return PayPal;

});
